import { api } from '../../api/fetch';

export const getAsset = async (id: number) => {
  return await api.get(`/api/v1/asset/${id}`);
};

export default getAsset;
